<template>
    <div class="img-overlay" v-if="zoom">
		<div class="img-holder"> 
			<img :src="getImagenZoom()" class="img-img" />
            <v-btn small color="primary" dark fab class="img-close" @click="cerrarZoom()">
                <v-icon style="font-size:24px">close</v-icon>
            </v-btn>
			<!-- <a nohref="nohref" @click="cerrarZoom()" class="img-close">X</a>  -->
		</div>
	</div>
</template>

<script>
  export default {
    data() {
        return { zoom:false}
    },
    props: ['imgSrc','show','mainUrl'],
    methods:{
		cerrarZoom:function (index){
			this.reloadScrollBars();
			this.zoom=false;
			this.imagenZoomIdx=null;
			this.$root.$emit('zoom:off');
		},
		hacerZoom:function (index){
			this.zoom=this.show;
			this.unloadScrollBars();
		},
		getImagenZoom(){
			if (this.imgSrc==null){return;}
			let img = this.mainUrl + 'imagenes/fotos/' + this.imgSrc;
				
			return img;
        },
        reloadScrollBars() {
            document.documentElement.style.overflow = 'auto';  // firefox, chrome
            document.body.scroll = "yes"; // ie only
        },
        unloadScrollBars() {
            document.documentElement.style.overflow = 'hidden';  // firefox, chrome
            document.body.scroll = "no"; // ie only
        }
    },
    watch: {
		show: function (val) {
			if (val==true){
				this.hacerZoom();
			}
		}
	}
  }
</script>
<style>
.img-overlay {
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, .9);
	text-align: center;
	z-index: 10;
	box-sizing: border-box;
	display: flex;
	align-items: center;
}

.img-holder {
	/* max-width: 600px; */
	margin: 0 auto;
	position: relative;
	max-height: 100vh;
}

.img-close {
	right: 10px;
	top: 0;
	/* font-size: 30px;
	width: 50px; */
	/* opacity: .6; */
	z-index: 1000000;
	position: absolute;
	text-align: center;
	box-sizing: border-box;
	color: rgba(255, 255, 255, .7);
	background-color: rgba(0, 0, 0, .5);
}

.img-close:hover {
	color: white;
	background-color: rgba(0, 0, 0, .7);
}
.img-img {
	/* width: 100%;
    max-width: 600px; */
	cursor: pointer;
	box-sizing: border-box;
	display: block;
	max-height: 100vh;
	max-width: 100vw;
}
</style>